// extracted by mini-css-extract-plugin
export default {"dialog":"d5stgEpjx04xj3oA","subHeader":"rdBaH50jDDs493wv","header":"gkfj0H6MlSYqOGAz","warning":"AhZ9VNG33bIeYopS","texts":"yzVla7CeSIk5SZwa","mainButton":"bVsbuolXOjkNR1_M"};